import SelectMenu from './SelectMenu.vue';

export default SelectMenu;
